import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import Actions from "./actions";
var Types = Actions.Types;
var INITIAL_STATE = {
  account: {
    FirstName: null,
    LastName: null,
    HomePhone: null,
    ExternalCustomerId: null,
    receivedAt: null
  },
  receivedAt: Date.now(),
  showPersonalizationModal: false,
  transactionLimitInfo: {
    showTransactionLimitModal: false,
    transactionLimitReached: false
  }
};

var loyaltyReducer = function loyaltyReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case Types.ACCOUNT_DATA:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          account: _objectSpread({}, action.account),
          receivedAt: action.receivedAt
        });
      }

    case Types.RESET_ACCOUNT_DATA:
      {
        return {
          account: _objectSpread(_objectSpread({}, action.account), INITIAL_STATE.account),
          receivedAt: action.receivedAt
        };
      }

    case Types.SET_PERSONALIZATION_MODALS:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          showPersonalizationModal: action.showPersonalizationModal
        });
      }

    case Types.SET_TRANSACTION_LIMIT_INFO:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          transactionLimitInfo: _objectSpread(_objectSpread({}, state.transactionLimitInfo), action.transactionLimitInfo)
        });
      }

    default:
      {
        return state;
      }
  }
};

export default loyaltyReducer;